export class Driver {
  name: string;
  activities: FlightReportActivity[] = [];
}

export class FlightData {
  isArrival: boolean;
  aircraft: string;
  aircraftRegistration: string;
  airlineOperator: string;
  blockTime: string;
  diIndicator: string;
  flightId: string;
  flightServiceType: string;
  gate: string;
  isInvoiced: string;
  busIsNeeded: string;
  pax: string;
  scheduledTime: Date;
  stand: string;
}

export class FlightReport {
  flightData: FlightData;
  drivers: Driver[];
}

export class FlightReportActivity {
  type: string;
  started: Date;
  ended: Date;
  driver: string;
}

export class FlightReportExcelRow {
    status: string;
    startedDate: string;
    startedTime: string;
    ended: string;
    driver: string;
    flight_number: string;
    direction: string;
    planned_time: string;
}